<script context="module">
  import {
    get_three_previous_months,
    auffuellen,
    get_twelfe_previous_months_date,
    get_twelfe_previous_months_index_names,
    date_to_month_index_correct,
  } from "./Utils.svelte";
  import distinctColors from "distinct-colors";

  export function lead_data_all_to_month(data) {
    var date_dict = []; // create an empty array

    data.forEach((element) => {
      date_dict[element["create_date"].substring(0, 7)] = 0;
    });

    data.forEach((element) => {
      date_dict[element["create_date"].substring(0, 7)] = date_dict[element["create_date"].substring(0, 7)] + 1;
    });

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return first[0].localeCompare(second[0]);
    });

    return items;
  }

  export function get_previous_months(nr) {
    let return_list = [];

    var x = new Date();
    x.setDate(1);

    let i = 0;

    while (i < nr) {
      return_list.push(date_to_month_index_correct(x));
      x.setMonth(x.getMonth() - 1);
      i = i + 1;
    }

    return return_list;
  }

  export function specific_data_all_to_month_with_date_name(data, column_name, value_column_name) {
    var date_dict = []; // create an empty array

    //Letzten 18(?) Monate defaultmäßig einfügen:
    // console.log("get_twelfe_previous_months_index_names: ", get_twelfe_previous_months_index_names(get_twelfe_previous_months_date()))

    let previous_months_list = get_twelfe_previous_months_date();

    let initial = get_previous_months(18);

    // console.log('initial: ', initial);
    // console.log("data: ", data)
    let count = 0;
    initial.forEach((element) => {
      date_dict[element] = 0;
    });

    data.forEach((element) => {
      // console.log("currency: ", element['currency_id'])
      date_dict[element[column_name].substring(0, 7)] = 0;
    });

    data.forEach((element) => {
      date_dict[element[column_name].substring(0, 7)] = date_dict[element[column_name].substring(0, 7)] + element[value_column_name];
    });

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return first[0].localeCompare(second[0]);
    });

    return items;
  }

  export function converted_to_opportunity_month(data) {
    var date_dict = []; // create an empty array

    let opportunity_with_partner = 0;
    let opportunity_without_partner = 0;
    let lead_count = 0;

    data.forEach((element) => {
      if (element["date_conversion"]) {
        date_dict[element["date_conversion"].substring(0, 7)] = 0;
      }
    });

    data.forEach((element) => {
      if (element["date_conversion"]) {
        date_dict[element["date_conversion"].substring(0, 7)] = date_dict[element["date_conversion"].substring(0, 7)] + 1;
      }
    });

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return first[0].localeCompare(second[0]);
    });

    return { list: items, dict: date_dict };
  }

  export function lost_by_month(data, column = "date_closed") {
    var date_dict = []; // create an empty array
    var date_dict = []; // create an empty array

    let initial = get_three_previous_months();

    // console.log('initial: ', initial);
    // console.log("data: ", data)
    let count = 0;
    initial.forEach((element) => {
      date_dict[element] = 0;
    });

    // console.log('date_dict: ', date_dict);

    data.forEach((element) => {
      count = count + 1;
      // console.log("id: ", element['id'])
      if (element["id"] == 254850) {
        console.log("element haimberger: ", element);
      }

      if (element[column]) {
        date_dict[element[column].substring(0, 7)] = 0;
      }
      // if (element['x_studio_mitbewerb']){
      //   console.log("element: ", element)
      //   console.log("x_studio_mitbewerb: ", element['x_studio_mitbewerb'])
      // }
    });

    // console.log("count: ", count)

    data.forEach((element) => {
      if (element[column]) {
        date_dict[element[column].substring(0, 7)] = date_dict[element[column].substring(0, 7)] + 1;
      }
    });

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return first[0].localeCompare(second[0]);
    });

    return { list: items, dict: date_dict };
  }

  export function second_leads_highlights_left_corner(three_months, converted_to_opportunities) {
    // console.log('converted_to_opportunities: ', converted_to_opportunities);
    // console.log('converted_to_opportunities 0: ', converted_to_opportunities[three_months[0]]);

    return [
      converted_to_opportunities[three_months[0]],
      converted_to_opportunities[three_months[1]],
      converted_to_opportunities[three_months[2]],
    ];
  }

  export function filter_types(
    data,
    including_leads,
    including_opportunities,
    including_customers,
    including_aproach,
    including_qualified,
    including_gewonnen,
    including_proposition,
  ) {
    var date_dict = []; // create an empty array

    data.forEach((element) => {
      if (!including_leads) {
        if (element["type"] == "lead") {
          return;
        }
      }

      if (!including_opportunities) {
        if (element["type"] == "opportunity") {
          if (element["stage_id"][1] == "Gewonnen") {
          } else {
            return;
          }
        }
      }

      if (!including_customers) {
        if (element["stage_id"][1] == "Gewonnen") {
          return;
        }
      }

      if (!element["stage_id"]) {
        date_dict.push(element);
        // console.log('KOMMT DAS VOR? Es wurde keine Stage gesetzt. Sollte nicht vorkommen!');
        return;
      }

      if (!including_aproach) {
        if (element["stage_id"][1] == "Approach") {
          return;
        }
      }
      if (!including_qualified) {
        if (element["stage_id"][1] == "Analysis") {
          return;
        }
      }
      if (!including_gewonnen) {
        if (element["stage_id"][1] == "Gewonnen") {
          return;
        }
      }
      if (!including_proposition) {
        if (element["stage_id"][1] == "Offer") {
          return;
        }
      }

      //TODO Customer rausfinden

      date_dict.push(element);
    });

    return date_dict;
  }

  export function build_competition_table(data) {
    let ret_list = [];
    data.forEach((element) => {
      ret_list.push({
        name: element["display_name"],
        date_closed: element["x_date_closed"],
        country: element["x_country_id"][1],
        campaign: element["x_campaign_id"],
      });
    });

    return ret_list;
  }

  export function converted_to_opportunity_days(data) {
    var date_dict = []; // create an empty array

    // data.forEach((element) => {
    //   if (element['type'] != 'opportunity') {
    //     console.log("element['partner_id']: ", element['partner_id']);
    //     console.log("element['type']: ", element['type']);
    //   }
    // });

    data.forEach((element) => {
      if (element["date_conversion"] && element["type"] == "opportunity") {
        // console.log("element['type']: ", element['type'])
        date_dict[element["date_conversion"].substring(0, 10)] = 0;
      }
    });

    data.forEach((element) => {
      if (element["date_conversion"] && element["type"] == "opportunity") {
        date_dict[element["date_conversion"].substring(0, 10)] = date_dict[element["date_conversion"].substring(0, 10)] + 1;
      }
    });

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return first[0].localeCompare(second[0]);
    });

    return { list: items, dict: date_dict };
  }

  export function lead_data_all_to_country(data, countries) {
    var date_dict = []; // create an empty array

    countries.forEach((element) => {
      date_dict[element] = 0;
    });

    data.forEach((element) => {
      date_dict[element["country_id"][1]] = date_dict[element["country_id"][1]] + 1;
    });

    // // Create items array
    // var items = Object.keys(date_dict).map(function (key) {
    //   return [key, date_dict[key]];
    // });

    // // Sort the array based on the second element
    // items.sort(function (first, second) {
    //   return first[0].localeCompare(second[0]);
    // });

    return date_dict;
  }

  export function get_lost_reasons_from_lead(data) {
    let lost_reasons = [];
    let competition = [];

    data.forEach((element) => {
      if (!element["lost_reason"]) {
        return;
      }
      if (!element["lost_reason"][1]) {
        return;
      }
      if (!lost_reasons.includes(element["lost_reason"][1])) {
        lost_reasons.push(element["lost_reason"][1]);
      }

      if (element["lost_reason"][1] == "Lost to competitor") {
        if (!competition.includes(element["lost_reason"][1])) {
          competition.push(element["x_studio_mitbewerb"][1]);
        }
      }
    });

    return { lost_reasons: lost_reasons, competition: competition };
  }

  export function get_competition_from_lost_data(data) {
    let label_list = [];
    data.forEach((element) => {
      if (!element["mitbewerber"]) {
      } else {
        if (!label_list.includes(element["mitbewerber"]["x_name"][0])) {
          label_list.push(element["mitbewerber"]["x_name"][0]);
        }
      }
    });

    return label_list;
  }

  export function filter_lost_competitor(data, competitor) {
    let ret_list = [];
    data.forEach((element) => {
      if (!element["mitbewerber"]) {
        return;
      }
      if (element["mitbewerber"]["x_name"][0] == competitor) {
        ret_list.push(element);
      }
    });

    return ret_list;
  }

  export function filter_lost_reason(data, lost_reasons) {
    let ret_list = [];
    data.forEach((element) => {
      if (!element["lost_reason"]) {
        return;
      }
      if (lost_reasons.includes(element["lost_reason"][1])) {
        ret_list.push(element);
      }
    });

    return ret_list;
  }

  export function lead_count_sources(data) {
    var return_dict = {};
    var date_dict = {}; // create an empty array
    var label_list = [];

    data.forEach((element) => {
      if (!element["source_id"]) {
        date_dict["Unbekannt"] = 0;
      } else {
        date_dict[element["source_id"][1]] = 0;
        if (!label_list.includes(element["source_id"][1])) {
          label_list.push(element["source_id"][1]);
        }
      }
    });

    data.forEach((element) => {
      if (!element["source_id"]) {
        date_dict["Unbekannt"] = date_dict["Unbekannt"] + 1;
      } else {
        date_dict[element["source_id"][1]] = date_dict[element["source_id"][1]] + 1;
      }
    });

    let label_list_only_array = [];
    let dataset_list_only_array = [];

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return second[1] - first[1];
    });

    items.forEach((element) => {
      label_list_only_array.push(element[0]);
      dataset_list_only_array.push(element[1]);
    });

    return_dict["labels"] = label_list_only_array;
    return_dict["datasets"] = dataset_list_only_array;

    return return_dict;
  }

  export function lead_count_losses_mitbewerber(data) {
    var return_dict = {};
    var date_dict = {}; // create an empty array
    var label_list = [];

    // console.log('data: ', data);

    data.forEach((element) => {
      if (!element["mitbewerber"]) {
      } else {
        // console.log("element: ", element);
        date_dict[element["mitbewerber"]["x_name"][0]] = 0;
        if (!label_list.includes(element["mitbewerber"]["x_name"][0])) {
          label_list.push(element["mitbewerber"]["x_name"][0]);
        }
      }
    });

    // console.log('zwischen: ', date_dict);

    data.forEach((element) => {
      if (!element["mitbewerber"]) {
      } else {
        date_dict[element["mitbewerber"]["x_name"][0]] = date_dict[element["mitbewerber"]["x_name"][0]] + 1;
      }
    });

    let label_list_only_array = [];
    let dataset_list_only_array = [];

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return second[1] - first[1];
    });

    items.forEach((element) => {
      label_list_only_array.push(element[0]);
      dataset_list_only_array.push(element[1]);
    });

    return_dict["labels"] = label_list_only_array;
    return_dict["datasets"] = dataset_list_only_array;

    // console.log('AKtuelle Lost daten: ', return_dict);

    return return_dict;
  }

  export function lead_count_losses(data) {
    var return_dict = {};
    var date_dict = {}; // create an empty array
    var label_list = [];

    // console.log('data: ', data);

    data.forEach((element) => {
      if (!element["lost_reason"]) {
      } else {
        if (element["lost_reason"]["name"][0] == "Lost to competitor") {
          // console.log('element comp: ', element);
        }

        // console.log("element: ", element);
        date_dict[element["lost_reason"]["name"][0]] = 0;
        if (!label_list.includes(element["lost_reason"]["name"][0])) {
          label_list.push(element["lost_reason"]["name"][0]);
        }
      }
    });

    // console.log('zwischen: ', date_dict);

    data.forEach((element) => {
      if (!element["lost_reason"]) {
      } else {
        date_dict[element["lost_reason"]["name"][0]] = date_dict[element["lost_reason"]["name"][0]] + 1;
      }
    });

    let label_list_only_array = [];
    let dataset_list_only_array = [];

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return second[1] - first[1];
    });

    items.forEach((element) => {
      label_list_only_array.push(element[0]);
      dataset_list_only_array.push(element[1]);
    });

    return_dict["labels"] = label_list_only_array;
    return_dict["datasets"] = dataset_list_only_array;

    // console.log('AKtuelle Lost daten: ', return_dict);

    return return_dict;
  }

  export function lead_count_campaign(data) {
    var return_dict = {};
    var date_dict = {}; // create an empty array
    var label_list = [];

    data.forEach((element) => {
      if (!element["campaign_id"]) {
        date_dict["Unbekannt"] = 0;
      } else {
        date_dict[element["campaign_id"][1]] = 0;
        if (!label_list.includes(element["campaign_id"][1])) {
          label_list.push(element["campaign_id"][1]);
        }
      }
    });

    data.forEach((element) => {
      if (!element["campaign_id"]) {
        date_dict["Unbekannt"] = date_dict["Unbekannt"] + 1;
      } else {
        date_dict[element["campaign_id"][1]] = date_dict[element["campaign_id"][1]] + 1;
      }
    });

    let label_list_only_array = [];
    let dataset_list_only_array = [];

    // Create items array
    var items = Object.keys(date_dict).map(function (key) {
      return [key, date_dict[key]];
    });

    // Sort the array based on the second element
    items.sort(function (first, second) {
      return second[1] - first[1];
    });

    items.forEach((element) => {
      label_list_only_array.push(element[0]);
      dataset_list_only_array.push(element[1]);
    });

    return_dict["labels"] = label_list_only_array;
    return_dict["datasets"] = dataset_list_only_array;

    return return_dict;
  }

  function res_partner_link(text, id) {
    return (
      "<a" +
      ' target="_blank" ' +
      'href="https://smaxtec.odoo.com/web#id=' +
      id.toString() +
      '&action=129&model=res.partner&view_type=form&cids=1&menu_id=100">' +
      text.toString() +
      "</a>"
    );
  }

  function lead_link(text, id) {
    return (
      "<a" +
      ' target="_blank" ' +
      'href="https://smaxtec.odoo.com/web#id=' +
      id.toString() +
      '&action=897&model=crm.lead&view_type=form&cids=1&menu_id=121">' +
      text.toString() +
      "</a>"
    );
  }

  export function check_partners_in_lead(leads, partners) {
    partners.forEach((partner) => {
      leads.forEach((lead) => {
        if (lead["partner_id"]) {
          if (partner["id"] == lead["partner_id"][0])
            if (lead["stage_id"][1] == "Gewonnen") {
              console.log("partner: ", partner);
              console.log("lead: ", lead);
            }
        }
      });
    });
  }

  export function create_lead_since_data_from_all(data) {
    let lead_since_data = [];
    var today = new Date();

    // console.log('LEADDATA: ', data);

    data.forEach((element) => {
      var create_date_obj = new Date(element["create_date"]);
      let diffTime = Math.abs(today - create_date_obj);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      lead_since_data.push({
        days_since: auffuellen(diffDays.toString()),
        // name: '<a href="https://www.google.at">' + element['name'] + '</a>',
        partner: element["partner_id"] ? res_partner_link(element["partner_id"][1], element["partner_id"][0]) : "",
        country: element["country_id"] ? element["country_id"][1] : "",
        probability: auffuellen(element["probability"].toString()),
        source: element["source_id"][1],
        lead_link: lead_link(element["name"], element["id"]),
      });
    });

    return lead_since_data;
  }

  export function create_filtered_filters(data) {
    let return_dict = {};

    let countries_list = [];
    let sources_list = [];
    let campaigns_list = [];

    data.forEach((element) => {
      if (element["country_id"])
        if (!countries_list.includes(element["country_id"][1])) {
          countries_list.push(element["country_id"][1]);
        }

      if (element["campaign_id"])
        if (!campaigns_list.includes(element["campaign_id"][1])) {
          campaigns_list.push(element["campaign_id"][1]);
        }

      if (element["source_id"])
        if (!sources_list.includes(element["source_id"][1])) {
          sources_list.push(element["source_id"][1]);
        }
    });

    return_dict["countries_list"] = countries_list;
    return_dict["sources_list"] = sources_list;
    return_dict["campaigns_list"] = campaigns_list;

    return return_dict;
  }

  export function leads_highlights_left_corner(data) {
    let last_seven_days_count = 0;
    let last_month_count = 0;

    let last_seven_days_count_before = 0;
    let last_month_count_before = 0;

    let top_lead_finder_seven_days = {};
    let top_lead_finder_month = {};

    let top_lead_finder_seven_days_to_return = "-";
    let top_lead_finder_month_to_return = "-";

    let max = 10;

    data.forEach((element) => {
      if (element["date_conversion"] && max) {
        max = max - 1;
      }

      if (element["leadFinder"]) {
        top_lead_finder_seven_days[element["leadFinder"][1]] = 0;
        top_lead_finder_month[element["leadFinder"][1]] = 0;
      }
    });

    var today = new Date();
    data.forEach((element) => {
      var create_date_obj = new Date(element["create_date"]);
      let diffTime = Math.abs(today - create_date_obj);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays <= 7) {
        last_seven_days_count = last_seven_days_count + 1;
      }
      if (diffDays <= 31) {
        last_month_count = last_month_count + 1;
      }
      if (diffDays > 7 && diffDays <= 14) {
        last_seven_days_count_before = last_seven_days_count_before + 1;
      }
      if (diffDays > 31 && diffDays <= 62) {
        last_month_count_before = last_month_count_before + 1;
      }

      if (element["leadFinder"]) {
        if (diffDays <= 7) {
          top_lead_finder_seven_days[element["leadFinder"][1]] = top_lead_finder_seven_days[element["leadFinder"][1]] + 1;
        }
        if (diffDays <= 31) {
          top_lead_finder_month[element["leadFinder"][1]] = top_lead_finder_month[element["leadFinder"][1]] + 1;
        }
      }
    });

    var top_lead_finder_seven_days_array = Object.keys(top_lead_finder_seven_days).map(function (key) {
      return [key, top_lead_finder_seven_days[key]];
    });
    top_lead_finder_seven_days_array.sort(function (first, second) {
      return second[1] - first[1];
    });
    var top_lead_finder_month_array = Object.keys(top_lead_finder_month).map(function (key) {
      return [key, top_lead_finder_month[key]];
    });
    top_lead_finder_month_array.sort(function (first, second) {
      return second[1] - first[1];
    });

    if (top_lead_finder_seven_days_array.length > 0) {
      top_lead_finder_seven_days_to_return = top_lead_finder_seven_days_array[0][0];
    }
    if (top_lead_finder_month_array.length > 0) {
      top_lead_finder_month_to_return = top_lead_finder_month_array[0][0];
    }

    let last_seven_days_count_percentage =
      100 * Math.abs((last_seven_days_count_before - last_seven_days_count) / ((last_seven_days_count_before + last_seven_days_count) / 2));

    let last_month_count_percentage =
      100 * Math.abs((last_month_count_before - last_month_count) / ((last_month_count_before + last_month_count) / 2));

    let return_dict = {
      last_seven_days_count: last_seven_days_count,
      last_month_count: last_month_count,
      last_seven_days_percentage_vorzeichen: last_seven_days_count_before > last_seven_days_count ? false : true,
      last_month_vorzeichen: last_month_count_before > last_month_count ? false : true,
      top_lead_finder_seven_days: top_lead_finder_seven_days_to_return,
      top_lead_finder_month: top_lead_finder_month_to_return,
      last_seven_days_count_percentage: last_seven_days_count_percentage.toFixed(2),
      last_seven_days_count_before: last_seven_days_count_before,
      last_month_count_percentage: last_month_count_percentage.toFixed(2),
    };

    return return_dict;
  }

  export function bar_data_custom_colors(column_names, values, colors) {
    let return_dict = {
      labels: column_names,
      datasets: [
        {
          label: "",
          data: values,
          backgroundColor: colors,
          borderWidth: 2,
          // borderColor: ['rgba(255, 255, 255, 1)', 'rgba(255,  255, 255, 1)'],
          borderColor: colors,
        },
      ],
    };

    return return_dict;
  }

  export function create_multi_line_chart_dataset(column_names, multi_data, labels, custom_colors = false) {
    let return_dict = {
      labels: column_names,
      datasets: [],
    };

    var palette_array = [];

    // CommonJS
    // var distinctColors_obj = require('distinct-colors').default
    var palette;
    if (!custom_colors) {
      palette = distinctColors({ count: 100 }); // You may pass an optional config object
      let index = 1;
      palette.forEach((element) => {
        if (index > 3) {
          palette_array.push(element.toString());
        }
        index = index + 1;
      });
    } else {
      palette_array = custom_colors;
    }

    // console.log("palette_array: ", palette_array)

    let i = 0;

    multi_data.forEach(function (element) {
      let v = {
        label: labels[i],
        fill: true,
        lineTension: 0.3,
        backgroundColor: "rgba(225, 204,230, .3)",
        borderColor: palette_array[i],
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgb(205, 130,1 58)",
        pointBackgroundColor: "rgb(255, 255, 255)",
        pointBorderWidth: 3,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgb(0, 0, 0)",
        pointHoverBorderColor: "rgba(220, 220, 220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,

        data: element,
      };
      return_dict["datasets"].push(v);
      i = i + 1;
    });

    return return_dict;
  }

  export function create_line_chart_dataset(column_names, mql_data, sql_data) {
    return {
      labels: column_names,
      datasets: [
        {
          label: "<30%",
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(225, 204,230, .3)",
          borderColor: "rgb(205, 130, 158)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgb(205, 130,1 58)",
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 10,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(0, 0, 0)",
          pointHoverBorderColor: "rgba(220, 220, 220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: mql_data,
        },
        {
          label: ">=30%",
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(184, 185, 210, .3)",
          borderColor: "rgb(35, 26, 136)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgb(35, 26, 136)",
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 10,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(0, 0, 0)",
          pointHoverBorderColor: "rgba(220, 220, 220, 1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: sql_data,
        },
      ],
    };
  }

  export function create_single_line_chart_dataset(column_names, mql_data, pointBorderWidth = 10, line_color = "rgb(205, 130, 158)") {
    return {
      labels: column_names,
      datasets: [
        {
          label: "",
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(225, 204,230, .3)",
          borderColor: line_color,
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgb(205, 130,1 58)",
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: pointBorderWidth,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(0, 0, 0)",
          pointHoverBorderColor: "rgba(220, 220, 220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: mql_data,
        },
      ],
    };
  }
</script>
